import axios from 'axios'
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'

const URI = 'https://datosprofes.cpem46.edu.ar/Backendphp/iniciosession.php'

const IniciarSession = ({ setSeccion }) => {
  const [credentials, setCredentials] = useState({ username: '', password: '' })

const inicioSession = async () => {
  try {
    const formData = new URLSearchParams();
    formData.append('username', credentials.username.trim());
    formData.append('password', credentials.password.trim());

    const response = await axios.post(URI, formData, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      withCredentials: true,  // MUY IMPORTANTE para que PHP use la sesión
    });

    const data = response.data;

    if (data.user) {
      // No hay token, guardamos solo el user si querés localmente
      localStorage.setItem("user", JSON.stringify(data.user));

      setSeccion('datos');

      Swal.fire({
        title: 'Éxito',
        text: `Bienvenido ${data.user}`,
        icon: 'success',
      });
    } else {
      Swal.fire({
        title: 'Error',
        text: data.error || 'Usuario y/o contraseña incorrectos',
        icon: 'error',
      });
    }
  } catch (error) {
    console.error(error);
    Swal.fire({
      title: 'Error',
      text: 'Hubo un problema al iniciar sesión...',
      icon: 'error',
    });
  }
};



  return (
    <div>
      <div className="seccion_menu">
        <div className="seccion">
          <h2>CPEM N°46</h2>
          <div className="modal-content">
            <h1>INICIAR SESIÓN</h1>
            <div>
              <input
                type="text"
                placeholder="Nombre de usuario"
                value={credentials.username}
                onChange={(e) =>
                  setCredentials({ ...credentials, username: e.target.value })
                }
              />
            </div>
            <div>
              <input
                type="password"
                placeholder="Contraseña"
                value={credentials.password}
                onChange={(e) =>
                  setCredentials({ ...credentials, password: e.target.value })
                }
              />
            </div>
            <div className="boxinput">
              <button onClick={inicioSession} className="btn" type="submit">
                ACCESS
              </button>
              <button className="btn">
                <Link to="/" className="">
                  CANCELAR
                </Link>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default IniciarSession
